<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="localDate"
    transition="scale-transition"
    offset-y
    :close-on-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="calendar-input"
        :value="dateComputed"
        :label="$t('message.reviews.dateRange')"
        prepend-icon="icon-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="localDate"
      first-day-of-week="1"
      :locale="selectedLocale"
      color="primary"
      no-title
      scrollable
      range
      class="pa-2"
    >
      <div class="full-width">
        <div class="dates-select">
          <v-text-field
            v-model="dateFrom"
            :label="$t('message.common.dateFrom')"
            :disabled="!editDates"
            @keyup.enter="handleEditDatesBtn"
          ></v-text-field
          ><v-text-field
            v-model="dateTo"
            :label="$t('message.common.dateTo')"
            :disabled="!editDates"
            @keyup.enter="handleEditDatesBtn"
          ></v-text-field>
          <v-btn icon color="primary" @click="handleEditDatesBtn">
            <v-icon>
              {{ editDates ? "icon-check" : "icon-edit" }}
            </v-icon>
          </v-btn>
        </div>
        <div class="d-flex justify-space-between">
          <ui-button outlined transparent color="primary" @click="closeMenu"
            >{{ $t("message.reviews.cancel") }}
          </ui-button>
          <v-spacer></v-spacer>
          <ui-button outlined transparent color="primary" @click="handleDate()"
            >{{ $t("message.common.choose") }}
          </ui-button>
        </div>
      </div>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";
import { PERIOD } from "@/enums/period.enum";

export default {
  name: "FbDatePicker",
  props: {
    date: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localDate: null,
      dateFormatted: null,
      dateFrom: moment()
        .subtract(1, PERIOD.MONTH)
        .add(1, PERIOD.DAY)
        .format(FORMAT.DATE),
      dateTo: moment().format(FORMAT.DATE),
      editDates: false,
      menu: false
    };
  },
  computed: {
    dateComputed() {
      if (this.localDate && this.localDate[0] && this.localDate[1]) {
        return `${moment(this.localDate[0]).format(FORMAT.DATE)} - ${moment(
          this.localDate[1]
        ).format(FORMAT.DATE)}`;
      }
      return "";
    },
    selectedLocale() {
      return this.$store.state.settings.selectedLocale;
    }
  },
  created() {
    this.localDate = this.date;
  },
  methods: {
    handleDate() {
      if (this.localDate[1]) {
        this.localDate = [this.localDate[0], this.localDate[1]];
      } else {
        this.localDate = [this.localDate[0], this.localDate[0]];
      }

      this.$refs.menu.save(this.localDate);
      this.$emit("change", this.localDate);
    },

    closeMenu() {
      this.menu = false;
    },

    handleEditDatesBtn() {
      if (this.editDates) {
        this.setDates();
      }
      this.editDates = !this.editDates;
    },

    async setDates() {
      const oldDate = this.localDate;

      if (!moment(this.dateFrom).isValid()) {
        this.dateFrom = oldDate[0];
      }
      if (!moment(this.dateTo).isValid()) {
        this.dateTo = oldDate[1];
      }
      this.localDate = [this.dateFrom, this.dateTo];

      await this.$nextTick(() => {
        this.dateInputType = "manual";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dates-select {
  display: flex;
  align-items: center;
  padding: $spacing 0;
  border-top: 1px solid $light-3;
  margin-bottom: $spacing;

  .v-text-field {
    width: 100px;
    margin-bottom: -$spacing * 2;
  }

  & > :not(:last-child) {
    margin-right: $spacing;
  }
}

.calendar-input {
  margin-top: $spacing * 1.25;
  margin-bottom: $spacing * -1.25;
  max-width: 230px;
}
</style>
